import { onMounted, onUnmounted } from 'vue';

export function useInfiniteScroll(containerRef, isEnabled, callback) {
  const handleScroll = () => {
    if (!isEnabled) return;

    const container = containerRef.value;
    if (!container) return;

    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const fullHeight = document.documentElement.scrollHeight;

    const distanceFromBottom = fullHeight - (scrollPosition + windowHeight);

    if (distanceFromBottom < 100) {
      callback();
    }
  };

  onMounted(() => {
    if (isEnabled) {
      window.addEventListener('scroll', handleScroll);
    }
  });

  onUnmounted(() => {
    if (isEnabled) {
      window.removeEventListener('scroll', handleScroll);
    }
  });
}
